import React, { useEffect, useContext } from 'react';
import AuthContext from  "../../context/AuthContext";

const Logout = () => {
    const { logoutUser } = useContext(AuthContext);


    useEffect(() => {
        logoutUser();
    }, []);

    return (
        <>
        </>
    );
};

export default Logout;
